import React, { Component } from 'react';

class Wrapper extends Component {
  render() {
    return <div data-testid="main-wrapper" style={{margin: 40}}>{this.props.children}</div>
  }
}

export default Wrapper;
